export enum CallEventType {
  /* OACC - Operator Assisted Conference Call */
  Oacc = 'Oacc',
  Webinar = 'Webinar',
  Meeting = 'ManagedMeeting',
}
